// 👉 Redirects
export const redirects = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    name: 'index',
    redirect: () => ({ name: 'dashboards' }),
  },
]

export const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: () => import('@/pages/error.vue'),
    meta: {
      layout: 'blank',
      public: true,
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/pages/not-authorized.vue'),
    meta: {
      layout: 'blank',
      public: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login.vue'),
    meta: {
      layout: 'blank',
      unauthenticatedOnly: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/pages/forgot-password.vue'),
    meta: {
      layout: 'blank',
      unauthenticatedOnly: true,
    },
  },
]
